const products = [
  {
    id: "under-sink-organizer",
    title: "Under-Sink Organizer",
    category: "Home & Kitchen",
    price: "₹499",
    description:
      "Multi-purpose 2-tier expandable under-sink organizer rack for efficient kitchen & bathroom cabinet storage.",
    image: "/images/products/under-sink-organizer/Photo1.png",
    images: [
      "/images/products/under-sink-organizer/Photo1.png",
      "/images/products/under-sink-organizer/Photo2.png",
      "/images/products/under-sink-organizer/Photo3.png",
      "/images/products/under-sink-organizer/Side-View1.png",
      "/images/products/under-sink-organizer/Side-View2.png",
      "/images/products/under-sink-organizer/Top-view.png",
      "/images/products/under-sink-organizer/Photo-With-Dimensions.png",
    ],
    source: "affiliate",
    affiliateUrl: "https://amzn.in/d/0eDQofDJ",
    featured: true,
  },
  {
    id: "kitchen-tableware-storage-box-pack-1",
    title: "Kitchen Tableware Storage Box (Pack of 1)",
    category: "Home & Kitchen",
    price: "₹569",
    description:
      "Premium kitchen tableware storage box with dust-proof cover for spoons, forks, and cutlery organization.",
    image: "/images/products/kitchen-tableware-storage-box/Photo1.png",
    images: [
      "/images/products/kitchen-tableware-storage-box/Photo1.png",
      "/images/products/kitchen-tableware-storage-box/Combined-Images0.png",
      "/images/products/kitchen-tableware-storage-box/Fine-grained-image.png",
      "/images/products/kitchen-tableware-storage-box/Photo-with-dimensions.png",
    ],
    source: "affiliate",
    affiliateUrl: "https://amzn.in/d/02xtDjAE",
    featured: true,
  },
  {
    id: "kitchen-tableware-storage-box-pack-2",
    title: "Kitchen Tableware Storage Box (Pack of 2)",
    category: "Home & Kitchen",
    price: "₹949",
    description:
      "Value pack of 2 premium kitchen tableware storage boxes with dust-proof cover for complete kitchen organization.",
    image: "/images/products/kitchen-tableware-storage-box/Combined-Images1.png",
    images: [
      "/images/products/kitchen-tableware-storage-box/Combined-Images1.png",
      "/images/products/kitchen-tableware-storage-box/Combined-Images0.png",
      "/images/products/kitchen-tableware-storage-box/Photo1.png",
      "/images/products/kitchen-tableware-storage-box/Fine-grained-image.png",
      "/images/products/kitchen-tableware-storage-box/Photo-with-dimensions.png",
    ],
    source: "affiliate",
    affiliateUrl: "https://amzn.in/d/0aB7ir74",
    featured: true,
  },
  {
    id: "p4",
    title: "2-Tier Slide-Out Cabinet Organizer",
    category: "Home & Kitchen",
    price: "₹2,500",
    description:
      "Heavy-duty 2-tier organizer for under-sink or cabinet storage. Easy access to your items.",
    image: "/images/organizer-4.jpg",
    source: "affiliate",
    affiliateUrl:
      "https://www.flipkart.com/search?q=slide+out+cabinet+organizer",
    featured: true,
  },
  {
    id: "p5",
    title: "Compact Cutlery Drawer Organizer",
    category: "Home & Kitchen",
    price: "₹850",
    description:
      "Space-saving design for small drawers. Neatly stacks your cutlery.",
    image: "/images/organizer-5.jpg",
    source: "affiliate",
    affiliateUrl: "https://www.amazon.in/s?k=compact+cutlery+organizer",
    featured: true,
  },
  {
    id: "p6",
    title: "Hand Blender - 500W",
    category: "Electronics",
    price: "₹1,299",
    description: "Powerful hand blender with multiple speed settings.",
    image: "/images/hand-blender.jpg",
    source: "own",
    url: "/products/p6",
  },
];

export default products;
